import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceSpacesWithHyphens',
})
export class replaceSpacesWithHyphens implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value.replace(/ /g, '-');
  }
}
